import type { Config } from "tailwindcss";

const theme = {
  container: {
    padding: "1rem",
  },
  minWidth: {
    0: "0px",
    0.5: "2px",
    1: "4px",
    1.5: "6px",
    2: "8px",
    2.5: "10px",
    3: "12px",
    3.5: "14px",
    4: "16px",
    5: "20px",
    6: "24px",
    7: "28px",
    8: "32px",
    9: "36px",
    10: "40px",
    11: "44px",
    12: "48px",
    14: "56px",
    16: "64px",
    20: "80px",
    24: "96px",
    28: "112px",
    32: "128px",
    36: "144px",
    40: "160px",
    44: "176px",
    48: "192px",
    52: "208px",
    56: "224px",
    60: "240px",
    64: "256px",
    72: "288px",
    80: "320px",
    96: "384px",
    full: "100%",
    min: "min-content",
    max: "max-content",
  },
  screens: {
    xs: "540px",
    sm: "720px",
    md: "960px",
    lg: "1140px",
    xl: "1320px",
    xxl: "1320px",
  },
  spacing: {
    ["minus-px"]: "-1px",
    px: "1px",
    0: "0px",
    0.5: "2px",
    1: "4px",
    1.5: "6px",
    2: "8px",
    2.5: "10px",
    3: "12px",
    3.5: "14px",
    4: "16px",
    5: "20px",
    6: "24px",
    7: "28px",
    8: "32px",
    9: "36px",
    10: "40px",
    11: "44px",
    12: "48px",
    14: "56px",
    16: "64px",
    20: "80px",
    24: "96px",
    28: "112px",
    32: "128px",
    36: "144px",
    40: "160px",
    44: "176px",
    48: "192px",
    52: "208px",
    56: "224px",
    60: "240px",
    64: "256px",
    72: "288px",
    80: "320px",
    96: "384px",
  },
  fontFamily: {
    serif: ["Lora", "ui-serif", "Georgia", "Cambria", '"Times New Roman"', "Times", "serif"],
    "sans-serif": [
      "Poppins",
      "ui-sans-serif",
      "system-ui",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
      '"Noto Color Emoji"',
      "sans-serif",
    ],
    mono: [
      "ui-monospace",
      "SFMono-Regular",
      "Menlo",
      "Monaco",
      "Consolas",
      '"Liberation Mono"',
      '"Courier New"',
      "monospace",
    ],
  },
  fontSize: {
    xs: ["12px", { lineHeight: "16px", letterSpacing: "0.24px" }],
    sm: ["14px", { lineHeight: "20px", letterSpacing: "0.28px" }],
    base: ["16px", { lineHeight: "24px", letterSpacing: "0.32px" }],
    lg: ["18px", { lineHeight: "24px", letterSpacing: "0.36px" }],
    xl: ["20px", { lineHeight: "28px", letterSpacing: "0.4px" }],
    "2xl": ["24px", { lineHeight: "32px", letterSpacing: "0.48px" }],
    "3xl": ["28px", { lineHeight: "36px", letterSpacing: "0.56px" }],
    "4xl": ["32px", { lineHeight: "40px", letterSpacing: "0.64px" }],
  },
  borderRadius: {
    none: "0px",
    sm: "4px",
    base: "10px",
    lg: "16px",
    xl: "20px",
    full: "9999px",
  },
  extend: {
    backgroundImage: () => ({
      "gradient-bright": "linear-gradient(92deg, #FE901F 0%, #A94AC7 100%)",
      "gradient-light": "linear-gradient(108deg, #EDDDFC 0%, #FFECD9 100%)",
      "gradient-none": "none",
    }),
    colors: {
      "deep-blue": "#050530",
      purple: "#8B33FF",
      orange: "#FE8E23",
      white: "#FFFFFF",
      black: "#000000",
      "light-purple": "#F3EBFF",
      danger: "#F42020",
      warning: "#FFAB00",
      success: "#2ECC71",
      info: "#208EF4",
      "light-danger": "#FEE9E9",
      "light-warning": "#FFF7E5",
      "light-success": "#E5F6F0",
      "light-info": "#E9F4FE",
      "dark-neutral-1": "#050530",
      "dark-neutral-2": "#0A1946",
      "dark-neutral-3": "#19295C",
      "dark-neutral-4": "#3F4A77",
      "mid-neutral-1": "#5E678C",
      "mid-neutral-2": "#8990AC",
      "mid-neutral-3": "#CBCFDD",
      "light-neutral-1": "#DEE1EB",
      "light-neutral-2": "#DADFEF",
      "light-neutral-3": "#F4F6FA",
      "light-neutral-4": "#F9FBFE",
      "light-neutral-5": "#F2F5F9",
      transparent: "transparent",
    },
  },
};

export const themeTailwind = theme as typeof theme & Config["theme"];
